export default "__VITE_ASSET__BXTs0A2U__"